import React, { useState } from 'react';
interface EmailCaptureScreenProps {
  onSubmit: (email: string) => void;
}
export function EmailCaptureScreen({
  onSubmit
}: EmailCaptureScreenProps) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (firstName.trim() && lastName.trim() && email.trim()) {
      onSubmit(email);
    }
  };
  const inputClass = "w-full bg-white text-brand-dark rounded-xl p-4 text-lg focus:outline-none focus:ring-2 focus:ring-brand-accent shadow-inner";
  return <div className="flex flex-col w-full h-full min-h-screen bg-brand-dark text-white px-4 pt-24 pb-8" data-id="element-5">
      <div className="flex-1 flex flex-col" data-id="element-6">
        <h1 className="text-4xl font-bold text-white mb-4 leading-tight" data-id="element-7">
          Almost there.
        </h1>
        <p className="text-brand-surface/90 text-lg mb-10" data-id="element-8">
          Enter your email to access the downloads.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-id="element-9">
          <div className="flex gap-3" data-id="element-10">
            <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="First name" required className={inputClass} data-id="element-11" />
            <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Last name" required className={inputClass} data-id="element-12" />
          </div>

          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="name@example.com" required className={inputClass} data-id="element-13" />

          <button type="submit" className="w-full bg-brand-cta text-brand-dark py-4 rounded-xl font-bold text-lg hover:bg-brand-cta/90 transition-colors shadow-lg mt-2" data-id="element-14">
            Build My Kit
          </button>

          <p className="text-center text-brand-surface/60 text-sm mt-4" data-id="element-15">
            No account needed. Enter your email to access the downloads.
          </p>
        </form>
      </div>
    </div>;
}